import React from "react";
import { GuidanceMode } from "@/models/types";
import { useI18n } from "@/i18n/I18nContext";

const MODE_IDS: GuidanceMode[] = ["FOLLOW", "FLOW", "FREE"];

interface ModeSelectorProps {
  mode: GuidanceMode;
  onChange: (m: GuidanceMode) => void;
  compact?: boolean;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({ mode, onChange, compact }) => {
  const { tm } = useI18n();
  return (
    <div
      className="inline-flex items-center rounded-full p-1"
      style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
    >
      {MODE_IDS.map((id) => {
        const active = id === mode;
        return (
          <button
            key={id}
            data-testid={`guidance-mode-${id.toLowerCase()}-btn`}
            onClick={() => onChange(id)}
            className={`relative rounded-full font-mono tracking-widest transition-colors ${
              compact ? "px-3 py-1 text-[10px]" : "px-4 py-1.5 text-[11px]"
            } ${active ? "text-[#1a1204]" : "text-slate-400 hover:text-slate-200"}`}
            style={
              active
                ? {
                    background: "linear-gradient(135deg,#FDE68A,#F59E0B)",
                    boxShadow: "0 0 16px rgba(245,158,11,0.4)",
                  }
                : {}
            }
          >
            {tm("modes", id)}
          </button>
        );
      })}
    </div>
  );
};
